import {
  CATEGORY_SALES_SUCCESS,
  SALES_CATEGORY_BY_MONTH_LOADING
} from '../actions/CategorySalesAction';

const initialState = {
  amazon: {
    categorySalesData: null,
    isLoading: true
  },
  shopify: {
    categorySalesData: null,
    isLoading: true
  },
  wholesale: {
    categorySalesData: null,
    isLoading: true
  }
};

const categorySalesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CATEGORY_SALES_SUCCESS:
      return { ...state, [action.vendor]: { categorySalesData: action.data, isLoading: false } };
    case SALES_CATEGORY_BY_MONTH_LOADING:
      return { ...state, [action.vendor]: { ...state?.[action.vendor], isLoading: action.isLoading } };

    default:
      return state;
  }
};

export default categorySalesReducer;
